import useParamsUrl from "./useParamsUrl";
import useVehicleMethods from "./useVehicleMethods";
import { filterData, getFiltersInArray, pushDataToArray } from "utils/arrayUtils";

const useFilterMethods = (paramsFromUrl: any) => {
    const { filtersFromUrl, isFilteredFromUrl } = useParamsUrl(paramsFromUrl);
    const { getVehicleFilters } = useVehicleMethods();

    const prepareFiltersData = (originalFilterData: any, filtersFromParams: any) => {
        const filtersFromUI = getFiltersInArray(filtersFromParams);
        const additionalConditions: any = [];

        // aqui recorro los parametros que estan filtrados y ordenados para
        // agregar condiciones y luego pre filtrarlos
        filtersFromUI
            .filter((c) => c.isFiltered)
            .sort((a, b) => a.orderFiltered - b.orderFiltered)
            .forEach((d) => {
                additionalConditions.push({
                    conditionNumber: Number(d.orderFiltered),
                    condition: {
                        label: d.filterName,
                        type: d.filterType,
                        values: d.values,
                    },
                });

                d.conditions = additionalConditions
                    .filter((m: any) => m.conditionNumber < d.orderFiltered)
                    .map((x: any) => x.condition);
            });

        const dataProcessed: any[] = [];

        filtersFromUI.forEach((item) => {
            if (item.isFiltered) {
                const currentData = filterData(originalFilterData, item) as any[];
                pushDataToArray(dataProcessed, currentData);
            } else {
                const currentData = filterData(originalFilterData, {
                    ...item,
                    conditions: additionalConditions.map((x: any)=> x.condition),
                })  as any[];
                pushDataToArray(dataProcessed, currentData);
            }
        });

        return dataProcessed;
    };

    return {
        getVehicleFilters,
        prepareFiltersData,
        filtersFromUrl,
        isFilteredFromUrl,
    };

};

export default useFilterMethods;
